export const APP_CONFIG_DROPDOWNS = 'APP_CONFIG_DROPDOWNS';
export const EVENTS_LOG = 'EVENTS_LOG';
export const SYSTEM_EVENTS_LOG = 'SYSTEM_EVENTS_LOG';
export const LOGOUT = 'LOGOUT';
export const SET_PRINT_LAYOUT = 'SET_PRINT_LAYOUT';
export const RESET_LOGOUT_DATA = 'RESET_LOGOUT_DATA';